export interface Error404ResourcesInterface {
  title: string;
  description: string;
  returnTo: string;
  home: string;
  footer: string;
}

export const Error404ResourcesBS: Error404ResourcesInterface = {
  title: "Stranica nije pronađena",
  description:
    "Čini se da ste skrenuli na pogrešan put. Ne brinite... i najboljima se to dešava. Možda biste trebali provjeriti internet konekciju. Evo malog savjeta koji vam može pomoći da se vratite na pravi put.",
  returnTo: "Povratak na",
  home: "Početnu",
  footer: "Safe.ba – Sva prava zadržana.",
};

export const Error404ResourcesEN: Error404ResourcesInterface = {
  title: "Page not found",
  description:
    "It's looking like you may have taken a wrong turn. Don't worry... it happens to the best of us. You might want to check your internet connection. Here's a little tip that might help you get back on track.",
  returnTo: "Return to",
  home: "Home",
  footer: "Safe.ba – All rights reserved.",
};

export const Error404ResourcesDE: Error404ResourcesInterface = {
  title: "Seite nicht gefunden",
  description:
    "Es sieht so aus, als hätten Sie vielleicht eine falsche Abzweigung genommen. Keine Sorge... das passiert den Besten. Sie sollten vielleicht Ihre Internetverbindung überprüfen. Hier ist ein kleiner Tipp, der Ihnen helfen könnte, wieder auf den richtigen Weg zu kommen.",
  returnTo: "Zurück zu",
  home: "Startseite",
  footer: "Safe.ba – Alle Rechte vorbehalten.",
};
